import { useTranslation } from 'react-i18next'
import HelpView from '~/pages/help/HelpView'
import LearnerFrame from '~/pages/scorm/components/LearnerFrame'

/** Le centre d'aide dans le cadre de l'espace apprenant (#78). */
function LearnerHelpPage() {
  const { t } = useTranslation()

  return (
    <LearnerFrame label={t('help.title')}>
      <h1 className="mb-6 font-heading text-2xl font-bold tracking-tight sm:text-3xl">{t('help.title')}</h1>
      <HelpView />
    </LearnerFrame>
  )
}

export default LearnerHelpPage
